const SideMonitoring = (
  <>
    <path
      d="M17.8318 16.2705L13.414 12C12.9767 12.6128 12.4269 13.1442 11.793 13.567L16.2107 17.8375C16.4348 18.0542 16.7977 18.0542 17.0212 17.8375L17.8318 17.054C18.0559 16.8379 18.0559 16.4866 17.8318 16.2705Z"
      fill="url(#paint0_linear_3245_914)"
    />
    <path
      d="M15.5082 7.73728C15.5082 11.7185 12.1646 14.9746 8.00408 14.9746C3.84355 14.9746 0.5 11.7185 0.5 7.73728C0.5 3.75605 3.84355 0.5 8.00408 0.5C12.1646 0.5 15.5082 3.75605 15.5082 7.73728Z"
      fill="#F0F0F0"
      stroke="#999999"
    />
    <path
      d="M7.99991 12C7.97059 12 7.94159 11.9941 7.91469 11.9827C7.88779 11.9712 7.86356 11.9545 7.84351 11.9335L4.19628 8.10558C3.95832 7.86493 3.77391 7.57828 3.65476 7.26384C3.5356 6.94939 3.48432 6.61404 3.50416 6.27907C3.524 5.94411 3.61453 5.61686 3.77001 5.31812C3.92548 5.01938 4.14249 4.75569 4.40726 4.54379C4.67202 4.33189 4.97875 4.17642 5.30795 4.08725C5.63715 3.99809 5.98163 3.97718 6.3195 4.02586C6.65736 4.07454 6.98123 4.19174 7.27052 4.37002C7.55981 4.54829 7.8082 4.78374 7.99991 5.06141C8.19169 4.78355 8.44023 4.54795 8.72972 4.3696C9.01921 4.19125 9.3433 4.07406 9.68139 4.02547C10.0195 3.97688 10.3642 3.99797 10.6935 4.08738C11.0228 4.1768 11.3296 4.33259 11.5944 4.54484C11.8591 4.75709 12.076 5.02116 12.2312 5.32024C12.3865 5.61933 12.4766 5.94689 12.496 6.28208C12.5154 6.61728 12.4636 6.95276 12.3439 7.26721C12.2241 7.58165 12.0391 7.86817 11.8005 8.10853L8.1563 11.9335C8.13625 11.9545 8.11203 11.9712 8.08513 11.9827C8.05823 11.9941 8.02922 12 7.99991 12Z"
      fill="#F74B3B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3245_914"
        x1="14.8965"
        y1="12"
        x2="14.8965"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#595959" />
        <stop offset="1" stopColor="#999999" />
      </linearGradient>
    </defs>
  </>
)

export default SideMonitoring
